export const DEFAULT_MAX_LOAD_TIME = 15000;

export default { DEFAULT_MAX_LOAD_TIME };
